export default "__VITE_ASSET__1b282591__"